require('./offer-notification.scss');

riot.tag2('offer-notification', '<a href="#" class="offer-notification-close" onclick="{close}"> <acr-svg svg-id="close" svg-class="acr-icon" svg-viewbox="0 0 200 200"></acr-svg> </a> <h4 class="offer-notification-title"><sup>{disclaimerId}</sup><raw-html content="{title || \'\'}"></raw-html> </h4> <p class="offer-notification-copy"> <raw-html content="{description}"></raw-html> </p>', '', 'class="offer-notification {is-show: isShow} "', function(opts) {

const self = this;
self.isShow = false;
self.mixin('bus');
self.description = '';
self.title = '';

function open(args) {
  self.isShow = true;
  self.description = args.disclaimerCopy;
  self.title = args.title ? '' : args.disclaimerTitle;
  self.disclaimerId = args.disclaimerId;
  self.update();
}

function close() {
  self.isShow = false;
  self.description = '';
  self.title = '';
  self.disclaimerId = '';
  self.update();
}

self.close = close;

self.bus.on(self.bus.EVENTS.DISCLAIMER.OPENDISCLAIMER, open);
self.bus.on(self.bus.EVENTS.DISCLAIMER.CLOSEDISCLAIMER, close);
});
